import { DateTime } from 'luxon'

export function formatDocumentDate(datetime: string | null | undefined): string {
  if (!datetime?.trim()) return ''
  const dt = DateTime.fromISO(datetime)
  if (dt.isValid) return dt.toFormat('MMMM dd, yyyy')
  const parsed = DateTime.fromFormat(datetime, 'yyyy-MM-dd')
  if (parsed.isValid) return parsed.toFormat('MMMM dd, yyyy')
  return datetime
}

export function formatDocumentTime(datetime: string | null | undefined): string {
  if (!datetime?.trim()) return ''
  const dt = DateTime.fromISO(datetime)
  if (dt.isValid) return dt.toFormat('HH:mm')
  const timeMatch = datetime.match(/(\d{1,2}:\d{2})/)
  return timeMatch?.[1] ?? ''
}

export function splitAddressLines(address: string | null | undefined): [string, string] {
  if (!address?.trim()) return ['', '']
  const parts = address.split(',').map((p) => p.trim()).filter(Boolean)
  if (parts.length <= 2) return [parts[0] ?? '', parts[1] ?? '']
  const mid = Math.ceil(parts.length / 2)
  return [parts.slice(0, mid).join(', '), parts.slice(mid).join(', ')]
}

export function displayValue(value: string | null | undefined, fallback = ''): string {
  const trimmed = (value ?? '').trim()
  return trimmed || fallback
}

export function formatRateValue(
  value: string | null | undefined,
  currency: string | null | undefined
): string {
  const trimmed = (value ?? '').trim()
  if (!trimmed) return ''
  const num = parseFloat(trimmed)
  if (Number.isNaN(num)) return trimmed
  const cur = (currency ?? '').trim()
  if (!cur) return num.toFixed(2)
  return `${cur} ${num.toFixed(2)}`
}
